import { axiosRef } from '.';

export const deleteAllAddress = (payload: any) => {
  return axiosRef.delete(`/books/address_bulk_delete`, { data: payload }); // Ensure you pass data object to axiosRef.delete
};
export const deleteAllContact = (payload: any) => {
  return axiosRef.delete(`/books/contact_bulk_delete`, { data: payload });
};
export const deleteAllBroker = (payload: any) => {
  return axiosRef.delete(`/books/broker_bulk_delete`, { data: payload });
};
export const deleteAllPackages = (payload: any) => {
  return axiosRef.delete(`/books/package_bulk_delete`, { data: payload });
};
